import { createHttpLink } from '@apollo/client/link/http';
import { setContext } from '@apollo/client/link/context';
import { ErrorResponse, onError } from '@apollo/client/link/error';
import { ApolloClient, from, fromPromise, InMemoryCache } from '@apollo/client';
import { baseURL, refreshToken } from './refresh-token';
import { toastErrorLink } from './graphql-error';

const httpLink = createHttpLink({ uri: `${baseURL}/graphql` });

const authLink = setContext((_, context) => {
  const accessToken = localStorage.getItem('access_token');
  return {
    headers: {
      ...context.headers,
      Authorization: accessToken ? `Bearer ${accessToken}` : '',
    },
  };
});

const tokenExpiredErrorLink = onError((error) => {
  if (isAccessTokenExpired(error)) {
    const { operation, forward } = error;
    const refreshTokenPromise = fromPromise(
      refreshToken().catch(() => {
        return null;
      }),
    );
    return refreshTokenPromise
      .filter((auth) => !!auth)
      .flatMap((auth) => {
        operation.setContext({
          headers: {
            ...operation.getContext().headers,
            authorization: `Bearer ${auth?.access_token}`,
          },
        });
        return forward(operation);
      });
  }
});

const isAccessTokenExpired = (error: ErrorResponse) => {
  const { networkError } = error;
  return (
    networkError &&
    'statusCode' in networkError &&
    networkError.statusCode === 401
  );
};

export const graphql = new ApolloClient({
  link: from([toastErrorLink, tokenExpiredErrorLink, authLink, httpLink]),
  cache: new InMemoryCache({
    addTypename: false,
  }),
});
